export const PATIENT_FILE_TABS = {
  OVERVIEW: 'OVERVIEW',
  PROFILE: 'PROFILE',
  REMINDERS: 'REMINDERS',
  REPORTS: 'REPORTS',
  EKGS: 'EKGS',
  BLOOD_PRESSURES: 'BLOOD_PRESSURES',
  KARDIA_RX: 'KARDIA_RX',
  WEIGHTS: 'WEIGHTS',
};



// WEBPACK FOOTER //
// ./src/views/pages/PatientFile/PatientFileUtils.js